import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DateTimeModule } from '../date-time.module';
import { DurationComponent } from './duration.component';

@NgModule({
  imports: [CommonModule, DateTimeModule],
  declarations: [DurationComponent],
  exports: [DurationComponent],
})
export class DurationModule {}
